import { useContext, useEffect, useState } from "react";
import styles from "./styles/NotaryCard.module.css";
import lawyer_icon from "./styles/img/laywer_icon.svg";
import PhoneInput from "react-phone-input-2";
import { LanguageContext } from "../../Context/changeLanguageProvider";
import GreenTik from "./styles/img/green-tik.svg";
import TrusteePopupBenef from "./BenefTrusteePopup";
import { RenderAvatarImageForBenefPortal } from "../../Utils/renderAvatarImage";
export default function BenefTrusteeCard({ trustee, setModal, assets }) {
  const {
    additional_information,
    name,
    email,
    phone_number,

    profile_avatar,
    awareness_status: aware,
  } = trustee;

  const websiteCurrentLang = useContext(LanguageContext).language;
  // const [previewedLogo, setPreviewedLogo] = useState(undefined);
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  // useEffect(() => {
  //   if (
  //     profile_avatar &&
  //     profile_avatar !== null &&
  //     profile_avatar !== undefined
  //   ) {
  //     let extension = profile_avatar[0];
  //     if (extension === "/") extension = ".jpg";
  //     else if (extension === "i") extension = ".png";

  //     const imageUrl = `data:image/${extension};base64,${profile_avatar}`;
  //     setPreviewedLogo(imageUrl);
  //   }
  // }, [profile_avatar]);
  return (
    <div className={styles.trusteeBenefContainer}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "5px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            maxWidth: "50%",
            minWidth: "20%",
            marginTop: "5px",
          }}
        >
          <p
            className={styles.promotionContainerName}
            style={{
              width: "100%",
            }}
          >
            {name}
          </p>
        </div>
        {aware == "true" && (
          <div className={styles.awareContainer}>
            <img
              style={{
                width: "13px",
                height: "13px",
              }}
              src={GreenTik}
              alt="green tik"
            />
            <p className={styles.awareText}>{dublicatedcontent.aware}</p>
          </div>
        )}
        <div
          style={{
            borderRadius: "50%",
            alignSelf: "flex-start",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        >
          <RenderAvatarImageForBenefPortal
            name={name}
            avatar={profile_avatar}
            avatarContainerStyling={{ width: "61px", height: "61px" }}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          className={styles.promotionContainerItem}
          style={{
            fontWeight: "400",
            width: "80%",
          }}
        >
          <img
            style={{
              scale: "1.2",
            }}
            src={lawyer_icon}
            alt="icon"
          />
          <p>{email}</p>
        </div>
        {phone_number?.length > 0 && (
          <div
            className={styles.promotionContainerItem}
            style={{
              fontWeight: "400",
            }}
          >
            <img
              style={{
                scale: "1.2",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <PhoneInput
              inputClass={styles.legalPhoneInput}
              buttonClass={styles.legalHide}
              disableSearchIcon={true}
              value={phone_number}
            />
          </div>
        )}
        {additional_information.length > 0 && (
          <div
            className={styles.additionaInfoContainer}
            style={{
              fontWeight: "400",
              alignItems: "flex-start",
            }}
          >
            <img
              style={{
                scale: "1.2",
                marginTop: "4px",
              }}
              src={lawyer_icon}
              alt="icon"
            />
            <p onClick={() => {}}>
              <p>Additional Information:</p>
              <p>{additional_information}</p>
            </p>
          </div>
        )}{" "}
        <div
          className={styles.seeMoreContainer}
          onClick={() => {
            setModal(
              <TrusteePopupBenef
                onClose={() => setModal(undefined)}
                toEdit={trustee}
                assets={assets}
              />
            );
          }}
        >
          <p>{dublicatedcontent.seeMore}</p>
        </div>
      </div>
    </div>
  );
}
